import data from "@/data/data.json";

const state = {
  data: data,
  filterValues: [
    { name: "Bundesland", value: "state" },
    { name: "Zweck", value: "sector" },
    { name: "Alter der Organisation", value: "age_cat" },
    { name: "Budget", value: "budget" },
    { name: "Finanzierung", value: "financing" }
  ]
};
const getters = {
  getData: state => state.data,
  filterValues: state => state.filterValues,
  getSeries: state => filter => {
    return state.data[filter.question][filter.filter];
  },
  getLevels: state => question => {
    return state.data[question].levels;
  },
  getTitle: state => title => {
    return state.data[title].question_text;
  }
};
const mutations = {};
const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
